import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesIdsRequestMain } from './modules/ui/Main';

const IdsRequestPage = (
  <SuspensePage>
    <PagesIdsRequestMain />
  </SuspensePage>
);

export default IdsRequestPage;
